import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import {
  DEFAULT_NEGOTIATION_CONFIG,
  type NegotiationSignalConfig,
} from "@/lib/par/negotiationSuggestions";

export function useNegotiationConfig() {
  const [config, setConfig] = useState<NegotiationSignalConfig>(DEFAULT_NEGOTIATION_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data } = await (supabase as any)
        .from("negotiation_signal_config")
        .select("*")
        .limit(1)
        .maybeSingle();

      if (data) {
        setConfig({
          high_spend_quantile: data.high_spend_quantile,
          late_variance_stddev_days: data.late_variance_stddev_days,
          long_terms_min_days: data.long_terms_min_days,
          near_zero_capture: data.near_zero_capture,

          weight_mixed_terms: data.weight_mixed_terms,
          weight_paid_late: data.weight_paid_late,
          weight_high_spend: data.weight_high_spend,
          weight_no_discount: data.weight_no_discount,
          weight_paid_early_no_capture: data.weight_paid_early_no_capture,
          weight_long_terms: data.weight_long_terms,

          enabled_mixed_terms: data.enabled_mixed_terms,
          enabled_paid_late: data.enabled_paid_late,
          enabled_high_spend: data.enabled_high_spend,
          enabled_no_discount: data.enabled_no_discount,
          enabled_paid_early_no_capture: data.enabled_paid_early_no_capture,
          enabled_long_terms: data.enabled_long_terms,
        });
      }
      setLoading(false);
    })();
  }, []);

  const update = async (patch: Partial<NegotiationSignalConfig>) => {
    const next = { ...config, ...patch };
    setConfig(next);
    await (supabase as any)
      .from("negotiation_signal_config")
      .update({ ...patch, updated_at: new Date().toISOString() })
      .eq("singleton", true);
  };

  return { config, loading, update };
}
